import React, {useState} from 'react'
import {
    Grid
} from '@material-ui/core'
import {useDispatch} from 'react-redux'
import { useIntl } from 'src/common/razzle-platform-translate'
import {useAlert} from 'src/common/razzle-platform-components/alert'
import {accept, email, min, required} from 'src/common/razzle-platform-components/form-validators'
import {Form} from 'src/common/razzle-platform-components/form-fields'
import {DefaultCheckBoxField, DefaultPasswordField, DefaultSubmitButton, DefaultTextField} from 'src/common/razzle-platform-user/Authentication/components/defaultFields'
import {BASE_URL} from 'src/common/razzle-platform-user/configs'
import {useAuth} from 'src/common/razzle-platform-user/Authentication/hooks'


const RegisterForm = (props) => {

    const [isRegisterInProgress, setRegisterInProgress] = useState(false)
    const dispatch = useDispatch()
    const { closeAuthenticationDialog } = useAuth()
    const {errorAlert, successAlert} = useAlert()
    const { formatMessage } = useIntl()
    const { checkBoxField, passwordField, submitButton, textField } = props

    const handleSubmit = async (data) => {

        if (props.handleSubmit) {
           await props.handleSubmit(data)
        } else {
            setRegisterInProgress(true)
            try {
                await dispatch.userModel.register({data})
                closeAuthenticationDialog()
                successAlert(formatMessage({
                    id: 'Félicitations, vous avez été enregistré avec succès',
                    defaultMessage: 'Félicitations, vous avez été enregistré avec succès'
                }))
            } catch (error) {
                errorAlert(error)
            }
            setRegisterInProgress(false)
        }

    }

    const TextField = textField || DefaultTextField
    const PasswordField = passwordField || DefaultPasswordField
    const CheckBoxField = checkBoxField || DefaultCheckBoxField
    const SubmitButton = submitButton || DefaultSubmitButton

    return (
        <Form onSubmit={handleSubmit}>
            <Grid container={true} spacing={4}>
                <Grid item={true} xs={12}>
                    <TextField
                        inProgress={isRegisterInProgress}
                        name="last_name"
                        label={formatMessage({ id: 'Nom', defaultMessage: 'Nom' })}
                        type="text"
                        validate={[required()]}
                        required
                    />
                </Grid>
                <Grid item={true} xs={12}>
                    <TextField
                        inProgress={isRegisterInProgress}
                        name="first_name"
                        label={formatMessage({ id: 'Prénom', defaultMessage: 'Prénom' })}
                        type="text"
                        validate={[required()]}
                        required
                    />
                </Grid>
                <Grid item={true} xs={12}>
                    <TextField
                        inProgress={isRegisterInProgress}
                        type="email"
                        name="email"
                        label={formatMessage({ id: 'Email', defaultMessage: 'Email' })}
                        validate={[required(), email()]}
                        required
                    />
                </Grid>

                {props.children && props.children}

                <Grid item={true} xs={12}>
                    <PasswordField
                        inProgress={isRegisterInProgress}
                        name="password"
                        label={formatMessage({ id: 'Mot de passe', defaultMessage: 'Mot de passe'})}
                        required
                        // @ts-ignore
                        validate={[required(), min(6, formatMessage({ id: 'Le mot de passe doit contenir au moins 6 caractères', defaultMessage: 'Le mot de passe doit contenir au moins 6 caractères'}))]}
                    />
                </Grid>

                <Grid item xs={12} style={{paddingTop: 0}}>
                    <CheckBoxField
                        name="accept"
                        label={<p style={{margin: 0}} >{formatMessage({ id: "J'accepte", defaultMessage: "J'accepte"})}<a target="_blank" href={`${BASE_URL}${formatMessage({ id: 'conditions-generales-de-prestation', defaultMessage: 'conditions-generales-de-prestation'})}`} > <span style={{textDecoration: 'underline', color: "#000", fontWeight: 'bold'}} >{formatMessage({ id: 'les conditions', defaultMessage: 'les conditions'})}</span></a> {formatMessage({ id: "d'utilisation", defaultMessage: "d'utilisation"})}</p>}
                        validate={[required(), accept()]}
                        required
                        inProgress={isRegisterInProgress}
                    />
                </Grid>

                <Grid container={true} item={true} xs={12} direction="row" justify="center" style={{marginTop: 5}}>
                    <Grid item={true} xs={8}>
                        <SubmitButton inProgress={isRegisterInProgress} label={formatMessage({ id: "S'inscrire", defaultMessage: "S'inscrire"})} />
                    </Grid>
                </Grid>

            </Grid>
        </Form>
    )
}

export default RegisterForm
